module.exports = __webpack_public_path__ + "static/media/close-icon.f707d154.svg";